module.exports = __webpack_public_path__ + "img/About_Freelanceri_Zaradi.3df8c3f.svg";